import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Sidebar from "./components/Sidebar";
import LabTests from "./components/LabTests";
import Packages from "./components/Packages";
import OrganInfo from "./components/OrganInfo";
import Customers from "./components/Customers";
import Employees from "./components/Employees";
import Orders from "./components/Orders";
import Blogs from "./components/Blogs";
import Equipment from "./components/Equipment";
import News from "./components/News";
import BookingReports from "./components/BookingReports";
import Masters from "./components/Masters";
import Login from "./components/Login";
import './App.css';
import Departments from "./components/Departments";
import Banners from "./components/Banners";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';

    return (
        <Router>
            <Routes>
                {/* Login Route */}
                <Route
                    path="/login"
                    element={
                        isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
                    }
                />

                {/* Protected Routes */}
                <Route
                    path="/*"
                    element={
                        <ProtectedRoute>
                            <div className="layout-container">
                                <Sidebar />
                                <main className="main-content">
                                    <Routes>
                                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                                        <Route path="/dashboard" element={<Dashboard />} />
                                        <Route path="/lab-tests" element={<LabTests />} />
                                        <Route path="/packages" element={<Packages />} />
                                        <Route path="/organ-info" element={<OrganInfo />} />
                                        <Route path="/customers" element={<Customers />} />
                                        <Route path="/employees" element={<Employees />} />
                                        <Route path="/orders" element={<Orders />} />
                                        <Route path="/blogs" element={<Blogs />} />
                                        <Route path="/equipment" element={<Equipment />} />
                                        <Route path="/news" element={<News />} />
                                        <Route path="/booking-reports" element={<BookingReports />} />
                                        <Route path="/masters" element={<Masters />} />
                                        <Route path="/department-master" element={<Departments />} />
                                        <Route path="/banner-master" element={<Banners />} />
                                    </Routes>
                                </main>
                            </div>
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </Router>
    );
}

export default App;
